module.exports = __webpack_public_path__ + "static/media/2-tvorcheskie.1002935b.jpg";